// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z_mL","input":"styles_input__2JHpP"};